<script lang="ts">
    import {
      Button,
      Col,
      ButtonGroup,
      DropdownToggle,
      DropdownMenu,
      DropdownItem,
      Dropdown,
    } from 'sveltestrap'
    import Card from "../../Core/Card.svelte";
    import { Makeverticalbuttons, Vertical } from '../../../utils/Constant/Constant';
</script>
  
  <!-- Need to check checked checkbox design -->
<Col lg="6">
    <Card headerTitle={Vertical} cardBodyprops="btn-group-showcase">
      <div slot="customheader">
        <span>{Makeverticalbuttons}</span>
      </div>
      <div slot="contentbody">
        <ButtonGroup vertical>
          <Button color="primary" >Button</Button>
          <Button color="secondary" class="b-r-0">
            Button
          </Button>
          <Dropdown>
            <DropdownToggle color="success" caret class="b-r-0">
              Dropdown
            </DropdownToggle>
            <DropdownMenu class="dropdown-button-group">
              <DropdownItem>Another Action</DropdownItem>
              <DropdownItem>Another Action</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Button color="info" class="b-r-0">Button</Button>
          <Button color="warning" class="b-r-0">Button</Button>
          <Dropdown>
            <DropdownToggle color="danger" caret>
               Dropdown
            </DropdownToggle>
            <DropdownMenu class="dropdown-button-group">
              <DropdownItem>Another Action</DropdownItem>
              <DropdownItem>Another Action</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Dropdown>
            <DropdownToggle color="light" class="txt-dark" caret>
               Dropdown
            </DropdownToggle>
            <DropdownMenu class="dropdown-button-group">
              <DropdownItem>Another Action</DropdownItem>
              <DropdownItem>Another Action</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </ButtonGroup>
      </div>
    </Card>
</Col>